<template>
  <div>
    <b-row>
      <b-col class="bold">
        Sillón
        <div>
          <span style="color: #0069aa;">{{ seleccionInhabilitar.sillonSeleccionado }}</span>
        </div>
      </b-col>
      <b-col class="bold">
        Clínica
        <div>
          <span style="color: var(--color-dentalia); font-weight: bold">{{ nombreClinica }}</span>
        </div>
      </b-col>
    </b-row>
    <br>
    <b-row v-if="diasOperativos[0]">
      <b-col class="bold">
        Día
        <div><span style="color: #0069aa;">{{ diasOperativos[0].diaHabilitar }}</span></div>
      </b-col>
      <b-col class="bold">
        Horario inhabilitado
        <div>
          <span style="color: #0069aa;">
            {{ diasOperativos[0].horaInicio | formatoHoraEstandar }}
            -
            {{ diasOperativos[0].horaFin | formatoHoraEstandar }}
          </span>
        </div>
      </b-col>
    </b-row>
    <br>
    <b-row>
      <b-col><span class="bold">Fechas a rehabilitar</span></b-col>
    </b-row>
    <br>
    <b-row>
      <b-col class="d-flex justify-content-center ml-3">
        <span class="pr-2 mt-2" style="color: rgb(142 142 142); font-weight: 600;">Desde</span>
        <b-form-datepicker
            style="height: 20px"
            dropright
            id="hab-fecha-inicio"
            v-model="form.fechaInicio"
            placeholder="Fecha"
        ></b-form-datepicker>
      </b-col>
      <b-col class="d-flex justify-content-center">
        <span class="pr-2 mt-2" style="color: rgb(142 142 142); font-weight: 600;">Hasta</span>
        <b-form-datepicker
            style="height: 20px"
            dropright
            id="hab-fecha-fin"
            v-model="form.fechaFin"
            placeholder="Fecha"
            :min="form.fechaInicio"
        ></b-form-datepicker>
      </b-col>
    </b-row>
    <br>
    <b-row>
      <b-col align="right">
        <b-button variant="outline-primary" pill :disabled="!formularioValido" @click="onRehabilitar">
          <span>Rehabilitar</span>
        </b-button>
      </b-col>
      <b-col>
        <b-button variant="outline-secondary" pill @click="$emit('cerrar')">Cancelar</b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: "FormHabilitarSillon",
  props: {
    nombreClinica: { type: String, required: true },
    idClinica: { type: Number, required: true },
    diasOperativos: { type: Array, required: true },
    listaDias: { type: Array, required: true },
    seleccionInhabilitar: { type: Object, required: true },
  },
  data: () => ({
    form: {
      fechaInicio: null,
      fechaFin: null,
    },
  }),
  created() {
    if (this.seleccionInhabilitar.fechaSelecionada != null) {
      this.form.fechaInicio = this.seleccionInhabilitar.fechaSelecionada;
    }
  },
  computed: {
    formularioValido() {
      return this.form.fechaInicio != null && this.form.fechaFin != null;
    },
  },
  methods: {
    onRehabilitar() {
      const horario = this.diasOperativos[0] || {};
      this.$emit('guardar', {
        idClinica: this.idClinica,
        sillones: [this.seleccionInhabilitar.sillonSeleccionado],
        dias: this.listaDias.map(d => d.dia),
        fechaInicio: this.form.fechaInicio,
        fechaFin: this.form.fechaFin,
        horaInicio: horario.horaInicio,
        horaFin: horario.horaFin,
      });
    },
  },
}
</script>
